import React from "react";
import BlanketBasicInformation from "../../../../features/bonds/blanket/components/BasicInformation";
import BlanketDetailedInformation from "../../../../features/bonds/blanket/components/DetailedInformation";
import BlanketObligeeInformation from "../../../../features/bonds/blanket/components/ObligeeInformation";

export default {
  layout: "blanket",
  inlineTitle: () => "Guardianship Blanket Bond Request",
  blanketSteps: [
    "Basic Information",
    "Detailed Information",
    "Obligee Information",
  ],
  guestSupportContext: "Guest Blanket Bond Request",
  hasDuplicateDialog: false,
  hasEsignatureDialog: false,
  getIsGuest: (form) => form.isGuestBlanketRequest,
  renderBlanketStep: (activeStep, form) => {
    if (activeStep === 0) {
      return (
        <BlanketBasicInformation
          control={form.control}
          errors={form.errors}
          watch={form.watch}
          setValue={form.setValue}
          loadingCounties={form.loadingCounties}
          allCounties={form.allCounties}
          allCities={form.allCities}
          allStates={form.allStates}
          otherResidency={form.otherResidency}
          handleOtherResidencyChange={form.handleOtherResidencyChange}
          emailExists={form.emailExists}
          emailChecking={form.emailChecking}
          emailDialogOpen={form.emailDialogOpen}
          handleDialogClose={form.handleEmailDialogClose}
          handleDialogContinue={form.handleEmailDialogContinue}
          handleDialogCancel={form.handleEmailDialogCancel}
          handleEmailFieldChange={form.handleEmailFieldChange}
          handleGoogleCallback={form.handleGooglePrincipalAddress}
        />
      );
    }
    if (activeStep === 1) {
      return (
        <BlanketDetailedInformation
          control={form.control}
          errors={form.errors}
          watch={form.watch}
        />
      );
    }
    return (
      <BlanketObligeeInformation
        control={form.control}
        watch={form.watch}
        obligees={form.obligees}
        loadingObligees={form.loadingObligees}
        openObligeeDialog={form.openObligeeDialog}
        setOpenObligeeDialog={form.setOpenObligeeDialog}
        newObligee={form.newObligee}
        setNewObligee={form.setNewObligee}
        handleAddObligee={form.handleAddObligee}
        handleObligeeGoogleCallback={form.handleObligeeGoogleAddress}
        allCities={form.allCities}
        allStates={form.allStates}
      />
    );
  },
};
